import { useLocation } from "react-router-dom";
import { __ } from "@wordpress/i18n";
import MENU_CONFIG from "../NavMenu/MenuConfig";

export default function Breadcrumb() {
  const location = useLocation();
  const currentPath = location.pathname;

  let parent = null;
  let current = null;

  // Loop through each menu category (global, more, etc.)
  for (const categoryKey in MENU_CONFIG) {
    const category = MENU_CONFIG[categoryKey];

    // Loop through the category's menu items
    for (const item of category.items) {
      if (item.path === currentPath) {
        parent = category; // Set category title as parent
        current = item; // Set active menu item as current page
        break;
      }
    }

    if (current) break; // Stop loop once found
  }

  // If no parent is found, assume it's a standalone page
  if (!current) {
    current = { label: currentPath.replace("/", "").replace(/-/g, " ") }; // Format path to readable text
  }

  return (
    <div className="breadcrumb-title my-4" style={{marginLeft: "30px"}}>
      {/* Home Icon */}
      <img
        src={`${window.placAdminData.pluginUrl}/assets/images/home.svg`}
        alt="icon"
        className="icon"
      />

      {/* Show Parent if exists */}
      {parent ? (
        <span className="inactive" style={{ opacity: 0.5 }}>
          {` / ${__(parent.title, "access-control")} / `}
        </span>
      ) : (
        // If no parent, still show "/ Current Page"
        <span className="inactive" style={{ opacity: 0.5 }}>
          {" / "}
        </span>
      )}

      {/* Current Page Name */}
      <span className="active" style={{ opacity: 1 }}>
        {__(current.label, "access-control")}
      </span>
    </div>
  );
}
